/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { EnforcementCategoryEnum } from './enforcementCategoryEnum';
import { EnforcementStateEnum } from './enforcementStateEnum';


export interface EnforcementConfigRecord { 
    state?: EnforcementStateEnum;
    enforcement_category?: EnforcementCategoryEnum;
    service_type?: ServiceTypeEnum;
    exit_days?: any | null;
    entrance_threshold?: object;
    signal_required?: object;
    email_notification?: object;
    banner_notification?: object;
    toast_notification?: object;
    created_ts?: Date;
    updated_ts?: Date;
}
export namespace EnforcementConfigRecord {
}


